<template>
  <v-form ref="form" @submit.prevent>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field :rules="[rules.required]" v-model="crud.title" label="Title"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="crud.subtitle" label="Subtitle"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-textarea rows="3" v-model="crud.description" label="Description"></v-textarea>
      </v-col>
      <v-col cols="12">
        <span class="font-weight-semibold">
          Speaking Question Here
          <v-icon size="20" class="mb-1" color="black">mdi-arrow-down</v-icon>
        </span>
        <app-editor ref="content" v-model="crud.question_group.questions[0].content" />
      </v-col>
      <v-col cols="12">
        <v-file-input
          v-model="crud.question_group.questions[0].question_file"
          label="Audio"
          show-size
          prepend-icon
          append-icon="mdi-music"
          accept="audio/*"
        >
          <template
            v-slot:selection
            v-if="typeof crud.question_group.questions[0].question_file === 'string'"
            >You already saved a file. Click to save a new one...</template
          >
        </v-file-input>
      </v-col>
      <v-btn text @click="onSave" :loading="loading" color="#FF347C" class="d-flex ml-auto"
        >Save</v-btn
      >
    </v-row>
  </v-form>
</template>
<script>
import rulesMixin from "@/mixins/rulesMixin";
import restoreMixin from "@/mixins/restoreMixin";
import { postSpeaking, postQuestions } from "@/api/api";
import Editor from "@/components/Utils/Editor.vue";

export default {
  mixins: [rulesMixin, restoreMixin],
  components: {
    appEditor: Editor,
  },
  props: {
    data: {
      required: true,
      type: Object,
    },
    direction: {
      required: false,
      default: "",
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      crud: {
        title: "",
        subtitle: "",
        description: "",
        question_group: {
          name: "Speaking",
          questions: [
            {
              title: "Speaking",
              content: {
                type: "doc",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        type: "text",
                        text: "Write your questions here...",
                      },
                    ],
                  },
                ],
              },
            },
          ],
        },
      },
    };
  },
  computed: {
    teacher_lesson() {
      return this.$store.getters["admin/teacher_lesson"];
    },
    currentStep() {
      if (this.direction) {
        return this.$store.getters["admin/practice"];
      } else return this.$store.getters["admin/teacher_lesson"];
    },
  },
  methods: {
    async onSave() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      let crud = { ...this.crud };
      try {
        let direction;
        if (this.direction) direction = "practice";
        else direction = "teach";
        crud.speaking_step = this.currentStep.speaking_step;
        const response = await postSpeaking(crud, direction);
        this.crud.uuid = response.data.uuid;

        if (response.data.question_group.uuid) {
          this.crud.question_group.uuid = response.data.question_group.uuid;
        } else this.crud.question_group.uuid = response.data.question_group;

        this.crud.question_group.questions[0].content = JSON.stringify(
          this.crud.question_group.questions[0].content,
        );

        const questions = await postQuestions(this.crud.question_group);

        this.crud.question_group = questions;

        this.crud.question_group.questions[0].content = JSON.parse(
          this.crud.question_group.questions[0].content,
        );
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
      this.loading = false;
    },
  },
  watch: {
    "data.uuid"() {
      if (this.data) {
        this.crud = this.data;
        if (typeof this.crud.question_group.questions[0].content === "string") {
          this.crud.question_group.questions[0].content = JSON.parse(
            this.crud.question_group.questions[0].content,
          );
        }
        if (this.$refs.content) {
          this.$refs.content.editor.setContent(this.crud.question_group.questions[0].content);
        }
      }
    },
  },
  created() {
    if (this.data) {
      this.crud = this.data;
      if (typeof this.crud.question_group.questions[0].content === "string") {
        this.crud.question_group.questions[0].content = JSON.parse(
          this.crud.question_group.questions[0].content,
        );
      }
    }
  },
  mounted() {
    this.$refs.content.editor.setContent(this.crud.question_group.questions[0].content);
  },
};
</script>
